import {useDispatch,useSelector} from 'react-redux'
import {useState} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import LocaleCurrency from '../../LocaleCurrency/LocaleCurrency'
import LocaleDate from '../../LocaleDate/LocaleDate'
import UserThumbnail from '../../UserThumbnail/UserThumbnail'
import useCurrentUser from '../../../hooks/useCurrentUser'
import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'
import {userIsOwner} from '../../../util/util'
import {useInvoice} from './hooks'
import css from './Invoices.module.css'
import {
	removeInvoice,
	setEditor
} from './slice'
import {Link,useHistory} from 'react-router-dom'
import {useFinancialsDashboardTabs} from '../hooks'

const Invoice = ({id})=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isOwner = userIsOwner(user)
	const invoice = useInvoice(id)
	const statusPost = useApiStatusEnvAwarePost()
	const history = useHistory()

	const taxPercent = useSelector(
		state => state.settings.app.tax_percent
	)

	const [emailPending,setEmailPending] = useState(false)
	const handleEmailInvoice = ()=>{
		setEmailPending(true)
		statusPost('api/financials',{action:'sendInvoice',id},'invoice','email').then(res=>{
			setEmailPending(false)
		})
	}

	const handleRemove = ()=>{
		if(!window.confirm('Are you sure you want to remove this invoice?')) return
		dispatch(removeInvoice(id))
	}

	const handleEdit = ()=>{
		dispatch(setEditor({
			show:true,
			id
		}))
	}

	//delete packages don't have pricing or name data
	//so set a flag and use this to display something else
	const deletedPackage = !Boolean(invoice.item) && invoice.item_type === 'package'

	const {setActiveTab} = useFinancialsDashboardTabs()

	return (
		<div className={css.Invoice}>
			<div className="w-100">
				<div className="d-flex">
					<div>
						{(isOwner&&!invoice.non_client&&invoice.recipient.profile_pic)&&
							<div>
								<UserThumbnail src={invoice.recipient.profile_pic.url}/>
								<small>
									{invoice.recipient.user_name}
								</small>
							</div>
						}
						{(isOwner&&Boolean(invoice.non_client))&&
							<div>
								<small>
									Sent to: {invoice.recipient_email}
								</small>
							</div>
						}
						{invoice.line_item.item_name}
						{deletedPackage&&' Deleted'}
					</div>
					<div className="ml-auto">
						<div className="d-flex">
							{!deletedPackage
								?
								<span className="text-info">
									<LocaleCurrency
										amount={(invoice.line_item.price*(1+taxPercent/100)).toFixed(2)}
										ISO={invoice.line_item.iso}
									/>
								</span>
								: <small className="text-info">deleted package</small>
							}
							<span style={{width:'40px',display:'block',textAlign:'right'}}>
								{invoice.line_item.qty}
							</span>
						</div>
					</div>
				</div>
				<hr className="my-1"/>
				<div className="d-flex justify-content-between align-items-center">
					<div className="d-flex">
						<small className="mr-2 text-secondary">Date Created:</small>
						<small className="mr-2">
							<LocaleDate
								date={new Date(invoice.date_created.split(' ').join('T'))}
								includeTime={false}
							/>
						</small>
						<small className="mr-2 text-info">Due Date:</small>
						<small className="mr-2">
							<LocaleDate
								date={new Date(invoice.due_date.split(' ').join('T'))}
								includeTime={false}
							/>
						</small>
						{!Boolean(invoice.paid)&&
							<small className="text-danger">
								Open
							</small>
						}
						{(Boolean(invoice.paid)&&Boolean(invoice.date_paid))&&
							<>
								<small className="mr-2 text-success">Paid:</small>
								<small 
									onClick={()=>{
										setActiveTab('payments')
										history.push(`/financials_dashboard?date=${encodeURIComponent(invoice.date_paid.split(' ').join('T'))}`)
									}}
									className="text-primary" 
									style={{cursor:'pointer'}}
								>
									<LocaleDate
										date={new Date(invoice.date_paid.split(' ').join('T'))}
										includeTime={false}
									/>
								</small>
							</>
						}
					</div>
					<div className="d-flex align-items-center">
						{(!invoice.paid&&isOwner)&&
							<>
								<Button
									onClick={handleEdit}
									className="text-primary"
									variant="link"
									size="sm"
								>
									Edit
								</Button>
								<OverlayTrigger rootClose overlay={
									<Tooltip>Click to email this invoice</Tooltip>
								}>
									<Button
										onClick={handleEmailInvoice}
										disabled={emailPending}
										className="text-success"
										variant="link"
										size="sm"
									>
										Email {emailPending&&<Spinner animation="border" size="sm"/>}
									</Button>
								</OverlayTrigger>
								<Button
									onClick={handleRemove}
									className="text-danger"
									variant="link"
									size="sm"
								>
									Remove
								</Button>
							</>
						}
						{(!invoice.paid&&!isOwner)&&
							<Link to={`/pay-invoice?token=${invoice.token}`}>
								Pay Now
							</Link>
						}
					</div>
				</div>
			</div>
		</div>
	)
}


export default Invoice